import React, { useState } from "react";
import { Form, DatePicker, Select, Button } from "antd";

export const FormEditPauses = ({
	finishForm = () => {},
	selectPauseInput,
	setSelectPauseInput = () => {},
	reasons = [],
	pauses = [],
	isActivePauses = false,
}) => {
	const [disableInputs, setDisableInputs] = useState(pauses.map((_, index) => index));

	const [isModalEliminatePause, setIsModalEliminatePause] = useState(false);

	const actionButtonPause = (inputIndex, type = 0) => {
		const changueDisibale = [...disableInputs];
		const indexSelect = changueDisibale.indexOf(inputIndex);

		if (indexSelect === -1) {
			return;
		}

		if (type === 1) {
			setSelectPauseInput({ indexPause: indexSelect, isDelete: true });
			setIsModalEliminatePause(true);
			return;
		}

		changueDisibale.splice(indexSelect, 1);
		setSelectPauseInput({ indexPause: indexSelect, isDelete: false });

		setDisableInputs(changueDisibale);
	};

	return (
		<>
			{isModalEliminatePause && (
				<div className="fixed h-full w-full top-0 left-0 z-10 bg-black bg-opacity-50 flex justify-center items-center">
					<div className="w-[400px] bg-white rounded-[4px] p-4 flex flex-col gap-4">
						<div className="font-semibold">
							<p>Eliminar</p>
						</div>
						<div className="">
							<p>¿Estas seguro de eliminar pausa?</p>
						</div>
						<div className="w-full h-[40px] mt-4 overflow-hidden flex justify-end gap-4">
							<Button
								htmlType="button"
								onClick={() => {
									setSelectPauseInput({ indexPause: -1, isDelete: false });
									setIsModalEliminatePause(false);
								}}
							>
								Cancelar
							</Button>
							<Button onClick={finishForm} type="primary" htmlType="button" className="bg-primaryTwo">
								Guardar
							</Button>
						</div>
					</div>
				</div>
			)}
			<Form.List name="pausesData">
				{(fields) => {
					return (
						<>
							{fields.map(({ key, name, ...restField }, indexFields) => {
								let disableExtraButtons = selectPauseInput.indexPause === -1 ? false : key !== selectPauseInput.indexPause;

								if (disableInputs.length !== fields.length) {
									disableExtraButtons = true;
								}

								let disableInput = disableInputs.includes(key);

								if (isActivePauses) {
									disableExtraButtons = true;
									disableInput = true;
								}

								return (
									<div key={key} className="text-[12px]">
										<div className="grid grid-cols-2 gap-4 h-[70px]">
											<div className="flex flex-col gap-2">
												<p>Inicio</p>
												<Form.Item
													{...restField}
													name={[name, "init"]}
													rules={[
														{
															required: !disableInput,
															message: "Necesita una fecha",
														},
													]}
												>
													<DatePicker className="w-full" disabled={disableInput} size="small" />
												</Form.Item>
											</div>
											<div className="flex flex-col gap-2">
												<p>Final</p>
												<Form.Item
													{...restField}
													name={[name, "close"]}
													rules={[
														{
															required: !disableInput,
															message: "Necesita una fecha",
														},
													]}
												>
													<DatePicker className="w-full" disabled={disableInput} size="small" />
												</Form.Item>
											</div>
										</div>
										<div className="h-[50px]">
											<p>Motivos</p>
											<Form.Item
												{...restField}
												name={[name, "reason"]}
												rules={[
													{
														required: !disableInput,
														message: "Escoge uno por lo menos",
													},
												]}
											>
												<Select
													showSearch
													mode="multiple"
													placeholder={`Selecciona uno`}
													className="w-full"
													disabled={disableInput}
													size="small"
												>
													{reasons.map((pauseReason, index) => (
														<Select.Option key={`${index}-pausemotivos`} value={pauseReason.name}>
															<span style={{ textTransform: "capitalize" }}>{pauseReason.name}</span>
														</Select.Option>
													))}
												</Select>
											</Form.Item>
										</div>
										<div className="h-[40px] w-full flex gap-4">
											<div
												onClick={() => {
													actionButtonPause(key);
												}}
												disabled={disableExtraButtons}
											>
												<p className={` ${disableExtraButtons ? "text-gray-300" : "text-primaryTwo cursor-pointer"}`}>
                                                    Editar Pausa
												</p>
											</div>
											<div
												onClick={() => {
													actionButtonPause(key, 1);
												}}
												disabled={disableExtraButtons}
											>
												<p className={` ${disableExtraButtons ? "text-gray-300" : "text-[#E4404B] cursor-pointer"}`}>
                                                    Eliminar Pausa
												</p>
											</div>
										</div>
									</div>
								);
							})}
						</>
					);
				}}
			</Form.List>
		</>
	);
};
